/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Planning_TitleInputs */

const fr_create_planning_title = /** @type {((inputs: Create_Planning_TitleInputs) => LocalizedString) & { parts: (inputs: Create_Planning_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Create_Planning_TitleInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Créer un planning (Importer un planning existant)`)
		}),
		{
			parts: /** @type {(inputs: Create_Planning_TitleInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Créer un planning (" }, { type: "markup-start", name: "import", options: {}, attributes: {} }, { type: "text", value: "Importer un planning existant" }, { type: "markup-end", name: "import", options: {}, attributes: {} }, { type: "text", value: ")" }])
			})
		}
	)
);

const en_create_planning_title = /** @type {((inputs: Create_Planning_TitleInputs) => LocalizedString) & { parts: (inputs: Create_Planning_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Create_Planning_TitleInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Create a planning (Import an existing planning)`)
		}),
		{
			parts: /** @type {(inputs: Create_Planning_TitleInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Create a planning (" }, { type: "markup-start", name: "import", options: {}, attributes: {} }, { type: "text", value: "Import an existing planning" }, { type: "markup-end", name: "import", options: {}, attributes: {} }, { type: "text", value: ")" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Create a planning (Import an existing planning)" |
*
* @param {Create_Planning_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const create_planning_title = /** @type {((inputs?: Create_Planning_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs?: Create_Planning_TitleInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Create_Planning_TitleInputs, { locale?: "fr" | "en" }, { import: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Create_Planning_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_create_planning_title(inputs)
			return fr_create_planning_title(inputs)
		}),
		{
			parts: /** @type {(inputs?: Create_Planning_TitleInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Create_Planning_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (en_create_planning_title).parts?.(inputs) ?? [{ type: "text", value: en_create_planning_title(inputs) }]
				return /** @type {{ parts?: (inputs: Create_Planning_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (fr_create_planning_title).parts?.(inputs) ?? [{ type: "text", value: fr_create_planning_title(inputs) }]
			})
		}
	)
);